import { DeviceType } from './DeviceType';
import { DeviceUser } from './DeviceUser';
import { DeviceManufacturers } from './DeviceManufacturers';

export class Device {
    public id: number;
    public name: string;
    public serialeNumber: string;
    public status: number; // "0 = Deleted - 1 = Available - 2 = Rented - 3 = Damaged"
    public deviceManufacturer: DeviceManufacturers;
    public deviceType: DeviceType;
    public deviceUsers: DeviceUser[] = [];

    static fromDto(d): Device {
        const device = new Device();

        if (!d) {
            return null;
        }

        device.id = d.id;
        device.name = d.name;
        device.serialeNumber = d.serialeNumber;
        device.status = d.status;
        device.deviceManufacturer = d.deviceManufacturer;
        device.deviceType = d.deviceType;
        device.deviceUsers = d.deviceUsers;

        return d;
    }

}
